import { PillNavigation } from '@acorns/web-components'
import styled from 'styled-components'

import FormContainer from 'components/FormContainer'
import Layout from 'components/Layout'
import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const Container = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;

  @media (min-width: ${style(theme => theme.breakpoints.md)}px) {
    min-height: 500px;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background-color: ${style(theme => theme.colors.white)};
    bottom: 0;
    left: 0;
    padding: 10px 20px 20px 20px;
    position: fixed;
    width: 100%;
  }
`

export const LinkAccountContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
  align-items: center;

  button {
    margin-top: 10px;
    width: 200px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    padding-bottom: 30px;
  }
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-bottom: 30px;
  }
`

export const PresetValue = styled.button<{ selectedIndex: number }>`
  align-items: center;
  background-color: ${style(theme => theme.colors.ivory)};
  border-radius: 100px;
  border-width: 0;
  color: ${style(theme => theme.colors.slate)};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 31px;
  margin: 0 5px;
  min-width: 110px;
  position: relative;
  transition: opacity 150ms ease-in-out;
  flex-direction: column;
  flex: 1;

  &:hover {
    opacity: 0.9;
  }
  ${props =>
    props.selectedIndex === 1 &&
    `
    min-width: 0;
    max-width: 75px;
  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    flex: auto;
    min-width: calc(25% - 10px);
  }
  `}
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 5px;
  }
`

export const PresetValue2 = styled(PresetValue)`
  min-width: unset;
  width: 74px;
  flex: unset;
`

export const PresetValuesContainer = styled.div<{ selectedIndex: number }>`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  padding-bottom: 80px;
  width: 488px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 244px;
    padding-bottom: 30px;
    ${props =>
      props.selectedIndex === 1 &&
      `
      max-width: 332px;
      width: 100%;
      ${/* sc-sel */ PresetValue} {
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }`}
`

export const CurrencyInputContainer = styled.div`
  & > div:first-child {
    @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
      min-height: unset;
    }
  }
`

export const PresetValuesContainer2 = styled(PresetValuesContainer)`
  width: 100%;
  max-width: 488px;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    max-width: 244px;
    ${props =>
      props.selectedIndex === 1 &&
      `
      max-width: 332px;
    }
  }`}
`

export const Title = styled(Heading2)`
  font-size: 22px;
  line-height: 30px;
  margin-top: 30px;
  margin-bottom: 6px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: none;
  }
`

export const Subtitle = styled(Body)`
  margin: 0 auto 40px;
  max-width: 340px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 30px;
  }
`

export const StyledPillNavigation = styled(PillNavigation)`
  max-width: 300px;
  margin: 0 auto 40px;

  div {
    font-size: 14px;
    height: 44px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    max-width: none;
    width: 100%;
  }
`

export const Link = styled(Body)`
  color: ${style(theme => theme.colors.slate)};
  margin: 15px auto 0;
  text-decoration: underline;
  cursor: pointer;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 10px;
  }
`

export const Link2 = styled(Body)`
  color: ${style(theme => theme.colors.stone)};
  margin: 15px auto 0;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
`

export const StyledFormContainer = styled(FormContainer)`
  max-width: 100%;
  margin: 0 auto 60px;
  box-shadow: ${style(theme => theme.shadows.lgMedium)};
  border-radius: 10px;

  &&& {
    width: 315px;
    padding-bottom: 0;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    &&& {
      width: 100%;
    }
  }
`

export const FormRow = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  font-size: 14px;
  line-height: 22px;
`

export const RecurringAmount = styled.p`
  margin: 0 10px;
`

export const LayoutNoMobilePadding = styled(Layout)`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-bottom: 0px;
  }
`
